import { colors } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import "../styles/Legend.scss";
var legendLabels = require("../data/legend-labels.json");

type LegendConfig = {
  colorStops: Record<string, []>;
  selectedOptions: Record<string, [string, string[]]>;
};

const Legend: React.FC<LegendConfig> = ({ colorStops, selectedOptions }) => {
  var label =
    legendLabels[
      selectedOptions["Immigrant status"][0] +
        " - " +
        selectedOptions["Demographics"][0] +
        " - " +
        selectedOptions["Variable"][0]
    ];

  return (
    <div className="legend-container">
      <div className="legend-label">{label}</div>
      {colorStops.cols.map((color, i) => {
        return (
          <div className="legend-class">
            <div className="color-box" style={{ backgroundColor: color }}></div>
            <div className="cut">
              {colorStops.percent_final[i] +
                "% to " +
                colorStops.percent_final[i + 1] +
                "%"}
            </div>
          </div>
        );
      })}
      {/* <div className="legend-class">
        <div className="color-box" style={{ backgroundColor: "#d0cfd3" }}></div>
        <div className="cut">Missing</div>
      </div> */}
    </div>
  );
};

export default Legend;
